import { createFileRoute } from "@tanstack/react-router";
import { MessageCircle } from "lucide-react";
import { EmptyState } from "@/components/shared/EmptyState";

export const Route = createFileRoute("/_app/messenger/")({
	component: MessengerEmptyState,
});

function MessengerEmptyState() {
	return (
		<EmptyState
			icon={<MessageCircle size={48} />}
			title="Wähle eine Konversation"
			description="Wähle eine Konversation aus der Liste oder starte eine neue über die Profilseite."
			className="h-full"
		/>
	);
}
